<template>
  <div>
    <Row type="flex" :space-x="10" class="margin-right-left padding-top">
      <Cell>
        <div class="h-input-group" v-width="320">
          <DatePicker v-model="params.start" style="width: 130px" :clearable="false" :option="{end:params.end}"
                      format="YYYY-MM-DD"></DatePicker>
          <span class="h-input-addon">至</span>
          <DatePicker v-model="params.end" style="width: 130px" :clearable="false" :option="{start:params.start}"
                      format="YYYY-MM-DD"></DatePicker>
        </div>
      </Cell>
      <Cell>
        <input type="text" v-model="params.keyword" v-width="180" :placeholder="partnerLabel + '名称'"
               @keyup.enter="doSearch">
      </Cell>
      <Cell>
        <Button color="primary" icon="fa fa-search" :loading="loading" @click="doSearch">查询</Button>
        <Button color="primary" icon="fa fa-refresh" @click="loadList">刷新</Button>
        <Button color="primary" @click="add">新增{{ direction === 1 ? '销项' : '进项' }}发票</Button>
        <Button @click="doExport">导出</Button>
        <DropdownMenu button @click="importTrigger" :datas="importDatas">导入</DropdownMenu>
        <DropdownMenu button @click="batchTrigger" :datas="batchDatas">批量操作</DropdownMenu>
        <Button color="blue" v-if="direction === 2" @click="generateInbound">生成入库单</Button>
      </Cell>
    </Row>
    <div class="h-panel-body padding-top">
      <Table :datas="invoiceList" :border="true" :loading="loading">
        <TableItem :width="40" align="center">
          <div slot-scope="{data}">
            <input type="checkbox" v-model="data._checked" :disabled="!!data.voucherId">
          </div>
        </TableItem>
        <TableItem title="发票种类" :width="170">
          <template slot-scope="{data}">{{ typeText(data.invoiceType) }}</template>
        </TableItem>
        <TableItem title="发票号码" prop="invoiceNo" :width="130"></TableItem>
        <TableItem title="状态" :width="90" align="center">
          <template slot-scope="{data}">
            <span class="h-tag" :class="statusTagClass(data.status)">{{ statusText(data.status) }}</span>
          </template>
        </TableItem>
        <TableItem title="业务类型" prop="bizType" :width="100"></TableItem>
        <TableItem title="开票日期" prop="invoiceDate" :width="110"></TableItem>
        <TableItem :title="partnerLabel + '名称'" prop="partnerName" :width="160"></TableItem>
        <TableItem title="商品名称" :width="160">
          <template slot-scope="{data}">{{ goodsNames(data) }}</template>
        </TableItem>
        <TableItem title="合计金额" :width="120" align="right">
          <template slot-scope="{data}">{{ data.amount | numFormat }}</template>
        </TableItem>
        <TableItem title="税率" :width="80" align="center">
          <template slot-scope="{data}">{{ rateText(firstDetail(data).taxRate) }}</template>
        </TableItem>
        <TableItem title="合计税额" :width="110" align="right">
          <template slot-scope="{data}">{{ data.taxAmount | numFormat }}</template>
        </TableItem>
        <TableItem title="价税合计" :width="120" align="right">
          <template slot-scope="{data}">{{ data.totalAmount | numFormat }}</template>
        </TableItem>
        <TableItem title="存货单据" :width="90" align="center">
          <template slot-scope="{data}">
            <span v-if="data.inboundNo">{{ data.inboundNo }}</span>
            <span v-else>-</span>
          </template>
        </TableItem>
        <TableItem title="关联凭证" :width="90" align="center">
          <template slot-scope="{data}">
            <span class="h-tag h-tag-bg-blue" v-if="data.voucherId">已生成</span>
            <span v-else>-</span>
          </template>
        </TableItem>
        <TableItem title="操作" :width="220">
          <div class="actions" slot-scope="{data}">
            <span @click="generateVoucher(data)" v-if="!data.voucherId">生成凭证</span>
            <span @click="doCheck(data)" v-if="direction === 2 && data.status === 'NORMAL' && data.checkStatus !== 1 && !data.voucherId">勾选认证</span>
            <span class="h-tag h-tag-bg-green" v-else-if="direction === 2 && data.checkStatus === 1"
                  style="cursor: default;">已认证</span>
            <span @click="edit(data)">编辑</span>
            <span @click="remove(data)" v-if="!data.voucherId">删除</span>
          </div>
        </TableItem>
      </Table>
      <Pagination style="margin-top: 10px;" v-model="pagination" layout="total,sizes,pager,jumper"
                  @change="currentChange" small align="right"/>
    </div>

    <!--新增/编辑弹窗-->
    <Modal v-model="showForm" type="drawer-right" hasCloseIcon width="960">
      <div slot="header">{{ direction === 1 ? '销项' : '进项' }}发票</div>
      <Form ref="form" v-width="900" :labelWidth="110" :model="form" :rules="validationRules">
        <Row :space="16">
          <Cell>
            <FormItem label="发票种类" prop="invoiceType">
              <Select v-model="form.invoiceType" :datas="typeList" keyName="id" titleName="name"></Select>
            </FormItem>
            <FormItem label="业务类型" prop="businessType">
              <Select v-model="form.businessType" :datas="businessList" keyName="id" titleName="name"></Select>
            </FormItem>
            <FormItem label="业务日期" prop="businessDate">
              <DatePicker type="date" v-model="form.businessDate" format="YYYY-MM-DD"></DatePicker>
            </FormItem>
            <FormItem label="开票日期" prop="invoiceDate">
              <DatePicker type="date" v-model="form.invoiceDate" format="YYYY-MM-DD"></DatePicker>
            </FormItem>
            <FormItem label="发票号码" prop="invoiceNo">
              <input type="text" v-model="form.invoiceNo">
            </FormItem>
            <FormItem label="发票代码">
              <input type="text" v-model="form.invoiceCode">
            </FormItem>
          </Cell>
          <Cell>
            <FormItem :label="partnerLabel + '名称'" prop="partnerName">
              <input type="text" v-model="form.partnerName">
            </FormItem>
            <FormItem label="统一社会信用代码">
              <input type="text" v-model="form.partnerTaxNo">
            </FormItem>
            <FormItem label="发票状态" prop="status">
              <Radio v-model="form.status" :datas="statusRadios"></Radio>
            </FormItem>
            <FormItem label="备注">
              <input type="text" v-model="form.remark">
            </FormItem>
            <FormItem label="附件">
              <Button size="small" @click="uploadAttachment">上传附件</Button>
              <span class="gray-color" style="margin-left: 8px; font-size: 12px;">
                <a v-if="form.attachmentName && form.id"
                   :href="$api.invoice.invoice.attachmentUrl(form.id)" target="_blank">
                  {{ form.attachmentName }}
                </a>
                <template v-else>支持发票 PDF/图片/XML，单文件不超过 10MB</template>
              </span>
            </FormItem>
          </Cell>
        </Row>
        <FormItem label="发票明细">
          <div style="width: 100%; overflow-x: auto;">
            <table class="invoice-detail-table">
              <thead>
              <tr>
                <th style="width: 150px;">商品名称</th>
                <th style="width: 90px;">规格</th>
                <th style="width: 60px;">单位</th>
                <th style="width: 90px;">数量</th>
                <th style="width: 100px;">单价</th>
                <th style="width: 110px;">金额</th>
                <th style="width: 100px;">税率</th>
                <th style="width: 100px;">税额</th>
                <th style="width: 60px;">操作</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(row, index) in form.details" :key="index">
                <td><input type="text" v-model="row.goodsName"></td>
                <td><input type="text" v-model="row.spec"></td>
                <td><input type="text" v-model="row.unit"></td>
                <td><NumberInput v-model="row.quantity" :min="0" @input="calcRow(row)"></NumberInput></td>
                <td><NumberInput v-model="row.price" :min="0" @input="calcRow(row)"></NumberInput></td>
                <td><NumberInput v-model="row.amount" :min="0" @input="calcTax(row)"></NumberInput></td>
                <td>
                  <Select v-model="row.taxRate" :datas="rateList" keyName="id" titleName="name"
                          @change="calcTax(row)"></Select>
                </td>
                <td align="right">{{ row.taxAmount | numFormat }}</td>
                <td class="text-center"><span class="actions" @click="removeDetail(index)">删除</span></td>
              </tr>
              <tr v-if="!form.details.length">
                <td colspan="9" class="text-center">暂无明细，请点击"添加明细"</td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <td colspan="5" align="right"><b>合计</b></td>
                <td align="right">{{ totalAmount | numFormat }}</td>
                <td></td>
                <td align="right">{{ totalTax | numFormat }}</td>
                <td></td>
              </tr>
              <tr>
                <td colspan="7" align="right"><b>价税合计</b></td>
                <td align="right"><b>{{ totalPriceTax | numFormat }}</b></td>
                <td></td>
              </tr>
              </tfoot>
            </table>
          </div>
          <Button size="small" style="margin-top: 8px;" @click="addDetail">添加明细</Button>
        </FormItem>
      </Form>
      <div class="text-center">
        <Button color="green" @click="submit" :loading="loading">{{form.id?'更新':'保存'}}</Button>
        <Button @click="showForm=false" :loading="loading">取消</Button>
      </div>
    </Modal>

    <!--隐藏的文件选择框-->
    <input ref="invoiceImportInput" type="file" accept=".xlsx,.xls" style="display:none"
           @change="onImportFileChange">
    <input ref="invoiceAttachmentInput" type="file" accept=".pdf,.jpg,.jpeg,.png,.gif,.xml"
           style="display:none" @change="onAttachmentFileChange">
  </div>
</template>

<script>
import moment from 'moment';
import {exportCsv} from '../../js/common/export-file';

const round2 = (val) => Math.round((Number(val) || 0) * 100) / 100;

const emptyDetail = {
  goodsName: '',
  spec: '',
  unit: '',
  quantity: null,
  price: null,
  amount: null,
  taxRate: 0.13,
  taxAmount: 0
};

export default {
  name: 'InvoiceManage',
  props: {
    //1销项 2进项
    direction: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      invoiceList: [],
      typeList: [
        {id: 'digital_common', name: '数电票普票'},
        {id: 'digital_special', name: '数电票专票'},
        {id: 'common', name: '增值税普通发票'},
        {id: 'special', name: '增值税专用发票'}
      ],
      businessList: [
        {id: '销售收入', name: '销售收入'},
        {id: '服务收入', name: '服务收入'}
      ],
      statusList: [
        {id: 'NORMAL', name: '正常'},
        {id: 'VOID', name: '作废'},
        {id: 'RED_ALL', name: '全额红冲'},
        {id: 'RED_PART', name: '部分红冲'}
      ],
      statusRadios: [
        {key: 'NORMAL', title: '正常'},
        {key: 'VOID', title: '作废'},
        {key: 'RED_ALL', title: '全额红冲'},
        {key: 'RED_PART', title: '部分红冲'}
      ],
      rateList: [
        {id: 0.13, name: '13%'},
        {id: 0.09, name: '9%'},
        {id: 0.06, name: '6%'},
        {id: 0.03, name: '3%'},
        {id: 0, name: '0%'}
      ],
      batchDatas: [
        {title: '批量生成凭证', key: 'batchVoucher'}
      ],
      importDatas: [
        {title: '下载导入模板', key: 'template'},
        {title: '导入发票数据', key: 'import'}
      ],
      params: {
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment().endOf('month').format('YYYY-MM-DD'),
        keyword: ''
      },
      pagination: {
        page: 1,
        size: 20,
        total: 0
      },
      form: this.getEmptyForm(),
      validationRules: {
        required: ['invoiceType', 'businessType', 'invoiceDate', 'businessDate', 'invoiceNo', 'partnerName', 'status']
      },
      showForm: false,
      loading: false
    }
  },
  computed: {
    partnerLabel() {
      return this.direction === 1 ? '客户' : '供应商';
    },
    totalAmount() {
      return round2(this.form.details.reduce((sum, row) => sum + (Number(row.amount) || 0), 0));
    },
    totalTax() {
      return round2(this.form.details.reduce((sum, row) => sum + (Number(row.taxAmount) || 0), 0));
    },
    totalPriceTax() {
      return round2(this.totalAmount + this.totalTax);
    }
  },
  methods: {
    getEmptyForm() {
      return {
        id: null,
        direction: this.direction,
        invoiceType: 'digital_common',
        businessType: '销售收入',
        invoiceDate: moment().format('YYYY-MM-DD'),
        businessDate: moment().format('YYYY-MM-DD'),
        invoiceNo: '',
        invoiceCode: '',
        partnerName: '',
        partnerTaxNo: '',
        remark: '',
        attachmentName: '',
        status: 'NORMAL',
        details: []
      };
    },
    firstDetail(data) {
      return (data.details && data.details[0]) || {};
    },
    goodsNames(data) {
      if (data.details && data.details.length) {
        return data.details.map(row => row.goodsName).filter(name => !!name).join('、');
      }
      return data.goodsName || '';
    },
    typeText(key) {
      let item = this.typeList.find(val => val.id === key);
      return item ? item.name : (key || '-');
    },
    statusText(status) {
      let item = this.statusList.find(val => val.id === status);
      return item ? item.name : '-';
    },
    statusTagClass(status) {
      if (status === 'NORMAL') {
        return 'h-tag-bg-green';
      }
      if (status === 'VOID') {
        return 'h-tag-bg-red';
      }
      return 'h-tag-bg-yellow';
    },
    rateText(rate) {
      if (rate === null || rate === undefined || rate === '') {
        return '-';
      }
      return round2(Number(rate) * 100) + '%';
    },
    loadList() {
      this.loading = true;
      this.$api.invoice.invoice.list(Object.assign({direction: this.direction}, this.params, {
        page: this.pagination.page,
        pageSize: this.pagination.size,
        size: this.pagination.size
      })).then(({data}) => {
        this.invoiceList = (data.results || data.records || []).map(item => Object.assign({_checked: false}, item));
        this.pagination.total = data.total || 0;
      }).catch(() => {
        this.$Message.error('发票数据加载失败');
      }).finally(() => this.loading = false);
    },
    doSearch() {
      this.pagination.page = 1;
      this.loadList();
    },
    currentChange() {
      this.loadList();
    },
    addDetail() {
      this.form.details.push(Object.assign({}, emptyDetail));
    },
    removeDetail(index) {
      this.form.details.splice(index, 1);
    },
    calcRow(row) {
      if (row.quantity !== null && row.quantity !== '' && row.price !== null && row.price !== '') {
        row.amount = round2(Number(row.quantity) * Number(row.price));
      }
      this.calcTax(row);
    },
    calcTax(row) {
      if (row.amount !== null && row.amount !== '' && row.taxRate !== null) {
        row.taxAmount = round2(Number(row.amount) * Number(row.taxRate));
      } else {
        row.taxAmount = 0;
      }
    },
    add() {
      this.form = this.getEmptyForm();
      this.addDetail();
      this.showForm = true;
    },
    edit(data) {
      this.loading = true;
      this.$api.invoice.invoice.get(data.id).then(({data}) => {
        let invoice = data.invoice || data;
        let details = (data.details || invoice.details || []).map(row => Object.assign({}, emptyDetail, row, {
          quantity: row.quantity !== undefined ? row.quantity : row.qty
        }));
        this.form = Object.assign(this.getEmptyForm(), invoice, {
          partnerName: invoice.partnerName || invoice.customerName,
          partnerTaxNo: invoice.partnerTaxNo || invoice.taxNo || invoice.customerTaxNo,
          businessType: invoice.bizType || invoice.businessType,
          businessDate: invoice.bizDate || invoice.businessDate,
          details
        });
        this.showForm = true;
      }).catch(() => {
        this.$Message.error('发票详情加载失败');
      }).finally(() => this.loading = false);
    },
    submit() {
      let validResult = this.$refs.form.valid();
      if (!validResult.result) {
        return;
      }
      if (!this.form.details.length) {
        this.$Message.error('请至少添加一条发票明细！');
        return;
      }
      if (!this.form.details[0].goodsName) {
        this.$Message.error('请填写明细商品名称！');
        return;
      }
      this.loading = true;
      let data = Object.assign({}, this.form, {
        direction: this.direction,
        bizType: this.form.businessType,
        bizDate: moment(this.form.businessDate).format('YYYY-MM-DD'),
        partnerName: this.form.partnerName,
        partnerTaxNo: this.form.partnerTaxNo,
        customerName: this.form.partnerName,
        customerTaxNo: this.form.partnerTaxNo,
        invoiceDate: moment(this.form.invoiceDate).format('YYYY-MM-DD'),
        businessDate: moment(this.form.businessDate).format('YYYY-MM-DD'),
        amount: this.totalAmount,
        taxAmount: this.totalTax,
        totalAmount: this.totalPriceTax,
        details: this.form.details.map(row => ({
          id: row.id,
          goodsName: row.goodsName,
          spec: row.spec,
          unit: row.unit,
          qty: row.quantity,
          quantity: row.quantity,
          price: row.price,
          amount: round2(row.amount),
          taxRate: row.taxRate,
          taxAmount: round2(row.taxAmount)
        }))
      });
      this.$api.invoice.invoice[data.id ? 'update' : 'save'](data).then(() => {
        this.$Message('保存成功~');
        this.showForm = false;
        this.loadList();
      }).catch(() => {
        this.$Message.error('发票保存失败');
      }).finally(() => this.loading = false);
    },
    remove(data) {
      this.$Confirm('确认删除该发票？').then(() => {
        this.$api.invoice.invoice.delete(data.id).then(() => {
          this.$Message('删除成功~');
          this.loadList();
        }).catch(() => {
          this.$Message.error('删除失败');
        });
      });
    },
    generateVoucher(data) {
      this.$Confirm('确认为该张发票生成凭证？').then(() => {
        this.loading = true;
        this.$api.invoice.invoice.generateVoucher(data.id).then(() => {
          this.$Message('凭证生成成功~');
          this.loadList();
        }).catch(() => {
          this.$Message.error('凭证生成失败');
        }).finally(() => this.loading = false);
      });
    },
    batchTrigger(key) {
      if (key === 'batchVoucher') {
        this.batchVoucher();
      }
    },
    batchVoucher() {
      let ids = this.invoiceList.filter(item => item._checked && !item.voucherId).map(item => item.id);
      if (!ids.length) {
        this.$Message.error('请勾选未生成凭证的发票！');
        return;
      }
      this.$Confirm(`确认对选中的 ${ids.length} 张发票批量生成凭证？`).then(() => {
        this.loading = true;
        this.$api.invoice.invoice.batchGenerateVoucher(ids).then(() => {
          this.$Message('凭证批量生成成功~');
          this.loadList();
        }).catch(() => {
          this.$Message.error('批量生成凭证失败');
        }).finally(() => this.loading = false);
      });
    },
    doCheck(data) {
      this.$Confirm('确认勾选认证该进项发票？').then(() => {
        this.loading = true;
        this.$api.invoice.invoice.check(data.id).then(() => {
          this.$Message('勾选认证成功~');
          this.loadList();
        }).catch(() => {
          this.$Message.error('勾选认证失败');
        }).finally(() => this.loading = false);
      });
    },
    generateInbound() {
      let ids = this.invoiceList.filter(item => item._checked).map(item => item.id);
      if (!ids.length) {
        this.$Message.error('请勾选要生成入库单的进项发票！');
        return;
      }
      this.$Confirm(`确认将选中的 ${ids.length} 张进项发票生成入库单？`).then(() => {
        this.loading = true;
        this.$api.invoice.invoice.generateInbound(ids).then(({data}) => {
          this.$Message(`入库单生成完成：成功 ${data.successCount} 张，跳过 ${data.skippedCount} 张`);
          (data.unmatchedMaterials || []).slice(0, 5).forEach(name => {
            this.$Message.error('物料未匹配：' + name);
          });
          this.loadList();
        }).catch(() => {
          this.$Message.error('入库单生成失败');
        }).finally(() => this.loading = false);
      });
    },
    importTrigger(key) {
      if (key === 'template') {
        window.open(this.$api.invoice.invoice.template());
      } else {
        this.$refs.invoiceImportInput.click();
      }
    },
    onImportFileChange(e) {
      let file = e.target.files[0];
      e.target.value = '';
      if (!file) return;
      let formData = new FormData();
      formData.append('file', file);
      this.loading = true;
      this.$api.invoice.invoice.importInvoices(this.direction, formData).then(({data}) => {
        this.$Message(`导入完成：成功 ${data.successCount} 张，跳过 ${data.skippedCount} 张`);
        (data.messages || []).slice(0, 5).forEach(msg => this.$Message.error(msg));
        this.pagination.page = 1;
        this.loadList();
      }).catch(() => {
        this.$Message.error('发票导入失败');
      }).finally(() => this.loading = false);
    },
    uploadAttachment() {
      if (!this.form.id) {
        this.$Message.error('请先保存发票后再上传附件！');
        return;
      }
      this.$refs.invoiceAttachmentInput.click();
    },
    onAttachmentFileChange(e) {
      let file = e.target.files[0];
      e.target.value = '';
      if (!file) return;
      let formData = new FormData();
      formData.append('file', file);
      this.loading = true;
      this.$api.invoice.invoice.uploadAttachment(this.form.id, formData).then(({data}) => {
        this.form.attachmentName = data.attachmentName;
        this.form.attachmentPath = data.attachmentPath;
        this.$Message('附件上传成功~');
      }).catch(() => {
        this.$Message.error('附件上传失败');
      }).finally(() => this.loading = false);
    },
    doExport() {
      let headers = ['发票种类', '发票号码', '状态', '业务类型', '开票日期', this.partnerLabel + '名称', '商品名称',
        '合计金额', '税率', '合计税额', '价税合计', '存货单据', '关联凭证'];
      let rows = this.invoiceList.map(data => [
        this.typeText(data.invoiceType), data.invoiceNo, this.statusText(data.status), data.bizType || data.businessType,
        data.invoiceDate, data.partnerName || data.customerName, this.goodsNames(data),
        data.amount, this.rateText(this.firstDetail(data).taxRate), data.taxAmount, data.totalAmount,
        data.inboundNo || '', data.voucherId ? '已生成' : ''
      ]);
      exportCsv(`${this.direction === 1 ? '销项' : '进项'}发票`, headers, rows);
    }
  },
  mounted() {
    this.loadList();
  }
}
</script>

<style lang="less" scoped>
.invoice-detail-table {
  width: 100%;
  border-collapse: collapse;

  th, td {
    border: 1px solid #e2e2e2;
    padding: 4px;
    font-size: 12px;
  }

  th {
    background: #f5f5f5;
    text-align: center;
    font-weight: normal;
  }

  .h-number-input, .h-select {
    width: 100%;
  }
}
</style>
